<template>
    <span
        title="Je hebt een reservering voor dit programma"
        class="reserved-label"
    >
        Gereserveerd
    </span>
</template>

<style src="./ReservedLabel.less" lang="less"></style>
